// Public (unauthenticated) route prefixes — the single source of truth for the
// app's net-new public-route infra (ClickUp 868jxkz4p §10).
//
// Two places read this list and MUST stay in sync:
//   • App.js (AppRoutes)  — renders these paths OUTSIDE the app shell (no Sidebar
//     /Header, no protected <Routes> tree).
//   • AuthContext         — skips the "send logged-out users to the auth server"
//     redirect for these paths, so an unauthenticated visitor can actually load
//     them (and a logged-in visitor still gets their user resolved for gating).
//
// Add an entry here to expose a new public surface; both behaviours follow. An
// entry ending in "/" is a prefix; any other is matched whole, so it can't
// shadow a community slug that merely starts with the same word.
export const PUBLIC_PATH_PREFIXES = ["/mentoring/invite/", "/download", "/studio", "/studio/"];

export function isPublicPath(pathname = "") {
  return PUBLIC_PATH_PREFIXES.some((entry) =>
    entry.endsWith("/")
      ? pathname.startsWith(entry)
      : pathname === entry || pathname === `${entry}/`
  );
}
